import { render } from "./PartsFooter.vue?vue&type=template&id=45fbef8d"
import script from "./PartsFooter.vue?vue&type=script&lang=js"
export * from "./PartsFooter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__